import { GraphBuilder } from '../graph/builder';
import { ComponentDef } from './types';

export const multiTurnRlhfComponent: ComponentDef = {
  id: 'multi-turn-rlhf',
  name: 'Multi-turn RLHF',
  description: 'Train a model on multi-turn dialogues using turn-level rewards and a rolling context window.',
  category: 'training',
  params: [
    { name: 'd_model', label: 'Model dimension', type: 'number', default: 512, min: 64, max: 4096, step: 64 },
    { name: 'seq_len', label: 'Sequence length', type: 'number', default: 128, min: 1, max: 8192, step: 1 },
    { name: 'turns', label: 'Turns', type: 'number', default: 3, min: 2, max: 16, step: 1 }
  ],
  buildGraph: (params) => {
    const d_model = Number(params.d_model);
    const seq_len = Number(params.seq_len);
    const turns = Number(params.turns);

    const g = new GraphBuilder();
    g.input('context', [seq_len, d_model]);

    g.cache('history', 'context', [turns, seq_len, d_model]);
    g.linear('policy', 'history', [d_model, d_model]);
    g.linear('reward', 'policy', [d_model, 1]);
    g.metric('turn_reward', 'reward', 'Per-turn Reward');
    g.scale('update', 'turn_reward', 'PPO');
    g.output('out', 'update');
    return g.build();
  }
};
